import React from 'react'
import { ApiGetCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { formatDateToMMDDYYYY, LogInUserID, MMDDYYYY } from '../../JS/Common';
import GreyBoxForReports from './GreyBoxForReports';

export default function MassTechnician({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    async function GetTechnicianData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);

        setTimeout(() => {
            setalerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
            setLoading(false);
        }, 2000);

        setTimeout(() => {
            setalerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/reports/technician-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&userId=${LogInUserID}&flag=${downloadall}`);
        }, 0);
    }
    return (
        <GreyBoxForReports icon="faUsersGear" name={"Bulk Techinicians Report Download"} onclickfunc={GetTechnicianData} />
    )
}
